module.exports = __webpack_public_path__ + "img/24 ninios.d5e6734a.jpg";